import React, { useEffect, useState } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  FolderIconBlue,
  ArrowUpRightBlue,
  MasterCard,
  AmountYouWillEarnCard,
} from "../../../../constant/imagePath";
import { Container } from "react-bootstrap";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { Row, Col } from "react-bootstrap";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
import classes from "./StartWorkAndGetPaid.module.css";
import { Input } from "../../../../stories/Input/Input";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import JustToNotifyYou from "../../../Modals/CoachFlow/OnBoarding/JustToNotifyYou/JustToNotifyYou";
import HowDoesPricingWork from "../../../Modals/CoachFlow/OnBoarding/HowDoesPricingWork/HowDoesPricingWork";
import StartWorkAndGetPaidMobile from "./StartWorkAndGetPaidMobile";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../store/Actions/authAction";

function StartWorkAndGetPaidDesktop({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer.price
  );

  const [agreedToPolicy, setAgreedToPolicy] = useState(
    getDataFromRedux?.agreedToPolicy ? getDataFromRedux?.agreedToPolicy : []
  );
  const [priceForAnHour, setPriceForAnHour] = useState(
    getDataFromRedux?.priceForAnHour ? getDataFromRedux?.priceForAnHour : 45
  );
  const [paymentMethods, setPaymentMethods] = useState([
    { icon: MasterCard, title: "Credit or Debit Card" },
  ]);
  const [modal, setModal] = useState(false);
  const [openPricingModal, setOpenPricingModal] = useState(false);
  function saveDataIntoRedux() {
    dispatch(setPersonalData("price", { priceForAnHour, agreedToPolicy }));
  }
  return (
    <div className={classes.StartWorkAndGetPaid}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={"66.6%"} />
      </div>

      <Container fluid className={`${[classes.container].join(" ")}`}>
        <Row className={`g-0 ${[classes.row].join(" ")}`}>
          <Col md={12}>
            <Row className={`g-0 ${classes.firstRow}`}>
              <Col md={12} className={`${[classes.saveAndFinish].join(" ")}`}>
                <LinkButtonWithIcon
                  text={"Save and Finish Later"}
                  customStyle={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                  onClick={saveDataIntoRedux}
                />
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Container fluid className={` ${classes.innerContainer}`}>
              <Col md={12}>
                <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
                  Start work and get paid
                </h3>

                <p
                  style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
                >
                  Set your lesson price for your 1-on-1 lesson
                </p>
              </Col>
              {/* Lesson Price Card */}
              <Col
                md={12}
                className={`${[classes.setLessonPriceCard].join(" ")}`}
                style={{ border: `1px solid ${Colors.neutralShadesOfWhisper}` }}
              >
                <Row className="position-relative">
                  <Col md={6}>
                    <p>Set the price for 1 hour lessons USD</p>
                    <div className={classes.lessonInputAndPerHour}>
                      <Input
                        placeholder=""
                        customStyle={{ width: "120px" }}
                        type="number"
                        state={priceForAnHour}
                        setter={(e) => {
                          if (e.length < 5) {
                            setPriceForAnHour(e);
                          }
                        }}
                      />
                      <span
                        style={{
                          ...Fonts.h6,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        /1 hour
                      </span>
                    </div>
                    <p
                      className={`${[classes.lytesnapCharges].join(" ")}`}
                      style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
                    >
                      Lytesnap charges <span style={{ ...Fonts.h8 }}>10%</span>{" "}
                      of your listed lesson price
                    </p>
                    <LinkButtonWithIcon
                      text={"System fee info"}
                      rightIcon={ArrowUpRightBlue}
                      primary={true}
                      iconStyle={{ margin: "0px" }}
                    />
                  </Col>
                  <Col md={6} className={classes.cardPosition}>
                    <div className={classes.cardInnerData}>
                      <img src={AmountYouWillEarnCard} />
                      <h3 style={{ ...Fonts.h3, color: Colors.white }}>
                        ${priceForAnHour}{" "}
                        <span style={{ ...Fonts.p2 }}>/1 hour</span>
                      </h3>
                    </div>
                  </Col>
                </Row>
              </Col>
              {/* I have read and agreed to the pricing policy */}
              <Col md={12}>
                <div className={`${classes.mt32} ${classes.aCenter}`}>
                  <Checkbox
                    label={"I have read and agreed to the"}
                    value={agreedToPolicy}
                    setValue={setAgreedToPolicy}
                  />
                  &nbsp;
                  <span
                    style={{ color: Colors.mainBlue, ...Fonts.p1 }}
                    onClick={() => setOpenPricingModal(true)}
                  >
                    pricing policy
                  </span>
                </div>
              </Col>
              {/* Payout Methods */}
              <Col md={12} className={classes.payoutMethodsSection}>
                <h4
                  style={{
                    ...Fonts.h4,
                    color: Colors.neutralShadesOfNero,
                    fontSize: "26px",
                  }}
                >
                  Payout methods
                </h4>
                <p className={classes.firstLine}>
                  To get paid, you need to set up a payout method. Our secure
                  payment system supports several payout methods, which can be
                  set up below. Go to FAQ.
                </p>
                <p className={classes.secondLine}>
                  Lytesnap releases payouts about 24 hours after the end of the
                  lesson. The time it takes for the funds to appear in your
                  account depends on your payout method.
                </p>
              </Col>
              <Col md={12} className={classes.mt32}>
                <ul className={classes.paymentMethods}>
                  {paymentMethods?.map((item) => {
                    return (
                      <li
                        style={{
                          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                        }}
                      >
                        <img src={item?.icon} />
                        <span
                          style={{
                            ...Fonts.h7,
                            color: Colors.neutralShadesOfNero,
                            fontFamily: "inter-600",
                          }}
                        >
                          {item?.title}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </Col>
              <Col md={12} className={classes.mt32}>
                <Button
                  primary={true}
                  size={"Large"}
                  customStyle={{
                    padding: "12px 32px 12px 32px",
                    height: "56px",
                    width: "max-content",
                  }}
                >
                  Add payment method
                </Button>
              </Col>
            </Container>
          </Col>
          {/* Buttons Col */}
          <Col
            md={12}
            style={{
              borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
            }}
            className={classes.btnsCol}
          >
            <div className={classes.btnsBox}>
              <Button
                label={"Back"}
                size={"Large"}
                customStyle={{ width: "162px", height: "56px" }}
                onClick={() => stepForwardAndBackward(2, 3)}
              />
              <Button
                label={"Next"}
                primary={true}
                size={"Large"}
                customStyle={{ width: "162px", height: "56px" }}
                onClick={() => {
                  saveDataIntoRedux();
                  stepForwardAndBackward(3, 1);
                }}
              />
            </div>
          </Col>
        </Row>

        {/* Just To Notify Modal */}
        <JustToNotifyYou show={modal} setShow={setModal} />
        {/* How Does Pricing Work */}
        <HowDoesPricingWork
          show={openPricingModal}
          setShow={setOpenPricingModal}
        />
      </Container>
    </div>
  );
}

export default function StartWorkAndGetPaid({ stepForwardAndBackward }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? (
    <StartWorkAndGetPaidMobile
      stepForwardAndBackward={stepForwardAndBackward}
    />
  ) : (
    <StartWorkAndGetPaidDesktop
      stepForwardAndBackward={stepForwardAndBackward}
    />
  );
}
